var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.triggerTransition)?_c('v-card',_vm._b({class:_vm.cardClass + ' ehc-card',attrs:{"color":"rgb(255, 255, 255, .7)","flat":"","transition":"slide-y-transition","height":_vm.height}},'v-card',_vm.$attrs,false),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }